import { FormInputProps } from '../../../models'
import { useState } from 'react'

export const FormInputPassword = <TFormValues extends Record<string, unknown>>({
  onChange,
  nombre,
  nombreCampo,
  reglas,
  register,
  placeholder,
  errors,
  isObligatorio,
  className,
  maxLength,
  disabled,
  min,
  defaultValue,
}: FormInputProps<TFormValues>) => {
  const [mostrarContrasena, setMostrarContrasena] = useState(false)
  const inputProps = register ? register(nombreCampo, reglas) : undefined

  return (
    <>
      <div className={className}>
        {nombre && (
          <label className='form-label input-group-solid fs-4'>
            {nombre} {isObligatorio && <span className='text-danger'>*</span>}
          </label>
        )}

        <div className='input-group input-group-solid mb-5'>
          <input
            {...(inputProps ?? {})}
            autoComplete='off'
            type={mostrarContrasena ? 'text' : 'password'}
            className='form-control form-control-solid'
            placeholder={placeholder}
            maxLength={maxLength}
            required={isObligatorio}
            disabled={disabled}
            onChange={(e) => {
              inputProps?.onChange?.(e)
              onChange?.(e)
            }}
            min={min}
            defaultValue={defaultValue}
          />
          <span className='input-group-text' id='basic-addon1' style={{ marginLeft: '1px' }}>
            <i
              className={`${
                mostrarContrasena ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'
              } fs-3 text-primary`}
              style={{ cursor: 'pointer' }}
              onClick={() => {
                setMostrarContrasena(!mostrarContrasena)
              }}></i>
          </span>
        </div>

        {errors && errors[nombreCampo] && (
          <p className='text-danger text-end fs-5'>{errors[nombreCampo]?.message}</p>
        )}
      </div>
    </>
  )
}
